var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"ShCustomValueMapper",style:({
    color: _vm.props.map[_vm.props.prop] ? _vm.props.map[_vm.props.prop].color : _vm.props.map['default'].color,
    cursor: _vm.props.cursor || 'default',
  })},[_c('i',{class:("fas " + (_vm.props.map[_vm.props.prop] ? _vm.props.map[_vm.props.prop].icon : _vm.props.map['default'].icon))}),_vm._v("\n  "+_vm._s(_vm.props.map[_vm.props.prop] ? _vm.props.map[_vm.props.prop].label : _vm.props.map['default'].label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }